export class SubmitMyMPARequestResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "actionApprovalRequest",
            "baseName": "actionApprovalRequest",
            "type": "MPARequest",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SubmitMyMPARequestResponse.attributeTypeMap;
    }
    constructor() {
    }
}
